import { Observable } from 'rxjs';
import { ofType, StateObservable } from 'redux-observable';
import { filter, withLatestFrom, map } from 'rxjs/operators';
import { Action } from 'redux';
import AppState from '../../state';
import { LocationChangeAction, LOCATION_CHANGE } from 'connected-react-router';
import { LoadRelease } from '../action-creators';

export const loadReleaseFromURLEpic = (
  action$: Observable<Action>,
  state$: StateObservable<AppState>
) =>
  action$.pipe(
    ofType<Action, LocationChangeAction>(LOCATION_CHANGE),
    withLatestFrom(state$),
    map(([_, state]) => ({
      pathname: state.router.location.pathname,
      pathParts: state.router.location.pathname.split('/'),
      draftId: state.release.release?.id,
    })),
    filter((props) => {
      if (
        !(
          props.pathname.startsWith('/release/') ||
          props.pathname.startsWith('/upgrade-release/')
        )
      ) {
        return false;
      }
      if (
        props.pathname.startsWith('/release/') &&
        props.pathParts.length < 4
      ) {
        return false;
      }
      if (
        props.pathname.startsWith('/upgrade-release/') &&
        props.pathParts.length !== 4
      ) {
        return false;
      }

      const id = props.pathParts[3];
      if (props.draftId === id || id === 'undefined') {
        return false;
      }
      return true;
    }),
    map(
      (props) => new LoadRelease(props.pathParts[2], props.pathParts[3], true)
    )
  );
